import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';


/**
 * Child Component which is a modal for delete a setting value or a setting description
 */
@Component({
    selector: 'app-delete-form-settings',
    templateUrl: './delete-form.component.html',
    styleUrls: ['./delete-form.component.scss'],
    standalone: true,
    providers: [NgbModalConfig, NgbModal],
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class DeleteFormComponent {

  @Input() vtodelete?:any
  @Input() parameter?:string
  @Input() key?:string
  @Output() eventDelete=new EventEmitter<string>()
  @Input() description?:boolean


  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
    config.backdrop='static';
    config.keyboard=false;
  }

  open({content}: { content: any }){
    this.modalService.open(content, { centered: true })
  }

  confirmDelete(){
    if(this.key){
      this.eventDelete.emit(this.key)
    }
    else{
      this.eventDelete.emit(this.vtodelete)
    }
  }
}